import React, { useEffect, useState } from "react";

export function ScoreGauge({ score }) {
    const size = 200;
    const stroke = 14;
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const pct = Math.max(0, Math.min(1, score / 100));

    const [animated, setAnimated] = useState(0);
    useEffect(() => {
        // Trigger dasharray animation on mount by flipping to the real value next frame.
        const id = requestAnimationFrame(() => setAnimated(pct));
        return () => cancelAnimationFrame(id);
    }, [pct]);

    const color =
        score >= 70 ? "#10B981" : score >= 50 ? "#F59E0B" : "#EF4444";

    return (
        <div
            className="flex flex-col items-center"
            data-testid="score-gauge"
        >
            <div className="text-[11px] uppercase tracking-[0.2em] text-klareet-MUT font-mono mb-3">
                Your Clarity Score
            </div>
            <div className="relative" style={{ width: size, height: size }}>
                <svg width={size} height={size} className="-rotate-90">
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        stroke="#1A2540"
                        strokeWidth={stroke}
                        fill="transparent"
                    />
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        stroke={color}
                        strokeWidth={stroke}
                        fill="transparent"
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={circumference * (1 - animated)}
                        style={{
                            transition:
                                "stroke-dashoffset 1500ms cubic-bezier(.2,.8,.2,1)",
                        }}
                    />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <div
                        className="font-mono font-semibold tabular-nums text-5xl"
                        style={{ color }}
                    >
                        {score}
                    </div>
                    <div className="text-sm text-klareet-MUT font-mono">
                        / 100
                    </div>
                </div>
            </div>
        </div>
    );
}
